import { HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'
import { BrandColorTypes, GrayColorTypes, GreenColorTypes, OrangeColorTypes, PurpleColorTypes, RedColorTypes, TealColorTypes, YellowColorTypes } from '../../../@types'

export type TextSizeType = 'xl' | 'lg' | 'md' | 'sm' | 'xs'
export type TextWeightType = 'default' | 'bold' | 'black'
export type TextAlignType = 'center' | 'end' | 'justify' | 'left' | 'right' | 'start' | 'inherit' | 'initial' | 'unset'
export interface TextProps extends HTMLAttributes<HTMLDivElement> {
  flex?: number
  basis?: number
  color?: BrandColorTypes | GrayColorTypes | OrangeColorTypes | TealColorTypes | GreenColorTypes | YellowColorTypes | PurpleColorTypes | RedColorTypes
  size?: TextSizeType
  weight?: TextWeightType
  align?: TextAlignType
  block?: boolean
  whiteSpace?: boolean
  children?: React.ReactNode
}

// eslint-disable-next-line react/prop-types
export const Text: React.FC<TextProps> = ({ children, ...props }) => {
  return <StyledText {...props}>{children}</StyledText>
}

export default Text

Text.defaultProps = {
  size: 'md',
  weight: 'default',
  align: 'left',
}

const XL = css`
  font-size: 20px !important;
  line-height: 28px !important;
`

const LG = css`
  font-size: 18px !important;
  line-height: 26px !important;
`

const MD = css`
  font-size: 16px !important;
  line-height: 24px !important;
`

const SM = css`
  font-size: 14px !important;
  line-height: 20px !important;
`

const XS = css`
  font-size: 12px !important;
  line-height: 18px !important;
`

const StyledText = styled.div<TextProps>`
  display: ${(p) => (p.block ? 'block' : 'inline-block')};
  ${(p) => p.block && 'width: 100%'};
  ${(p) => p.flex && `flex: ${p.flex}`};
  ${(p) => p.basis && `flex-basis: ${p.basis}px`};
  text-align: ${(p) => p.align} !important;
  color: ${(p) => (p.color ? `var(--${p.color})` : 'inherit')} !important ;
  ${(p) => p.whiteSpace && 'white-space: pre-wrap;'}

  ${(p) => {
    switch (p.size) {
      case 'xl':
        return XL
      case 'lg':
        return LG
      case 'sm':
        return SM
      case 'xs':
        return XS
      case 'md':
      default:
        return MD
    }
  }}

  ${(p) => {
    switch (p.weight) {
      case 'bold':
        return css`
          font-weight: 700 !important;
        `
      case 'black':
        return css`
          font-weight: 900 !important;
        `
      case 'default':
      default:
        return css`
          font-weight: 400 !important;
        `
    }
  }};
`
